var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-wrapper"},[_c('div',{staticClass:"widget-popup-tips"},[_c('p',{style:({color: _vm.data.color})},[_vm._v(_vm._s(_vm.data.word))]),_c('p',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(_vm.data.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }